import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-add-outsource-veh-v2',
  templateUrl: './add-outsource-veh-v2.component.html',
  styleUrls: ['./add-outsource-veh-v2.component.scss']
})
export class AddOutsourceVehV2Component {

  _mVehicleTypes: any[] = [];
  _mDriversData: any[] = [];
  registrationNo: any = '';
  vehicleType: any = '';
  mapToExistingDriver: boolean = false;
  driverName: any = '';
  licenseNumber: any = '';
  contactNumber: any = '';
  _mVMData: any = [];
  remark: any = '';

  constructor(
    public dialogRef: MatDialogRef<AddOutsourceVehV2Component>,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngxLoader: NgxUiLoaderService) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.getVehicleTypes();
  }

  getVehicleTypes() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getVehicleType, success => {
      if (success.status == 200) {
        this._mVehicleTypes = success.body;
        this._mVehicleTypes = this._mVehicleTypes.filter(
          vehicletype => vehicletype.status == AppConstants.ACTIVE_STATUS
        );
      }
    }, error => {
      console.log(error);
    });
  }

  discard_special_char_And_String(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || (k === 32));
  }

  discard_special_char(event) {
    var k;
    k = event.charCode;
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  onStatusChange() {
    this.driverName = '';
    this._mDriversData = [];
    this.licenseNumber = '';
    this.contactNumber = '';
    if (this.mapToExistingDriver) {
      this.getDriverDetails();
    }
    this.remark = '';
  }

  omit_special_char_And_num(event) {
    let k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  getDriverDetails() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getByvendor + this.data.vendorMasterId, (success) => {
      if (success.status == 200) {
        this._mDriversData = success.body;
      } else {
        this._mDriversData = [];
        this.notifyService.showWarning("No Drivers Found", null);
      }
    },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }

  onSelectDriver(event) {
    const driver = this._mDriversData.find(ele => ele.id == event.target.value);
    if (driver) {
      this.licenseNumber = driver.licenseNumber;
      this.contactNumber = driver.contactNumber;
    }
  }

  onConfirmation() {
    let sendData: any = '';
    if (this.mapToExistingDriver) {
      sendData = {
        "vehicleTypeId": this.vehicleType,
        "registrationNo": this.registrationNo,
        "siteId": this.data.siteId,
        "vendorMasterId": this.data.vendorMasterId,
        "driverId": this.driverName,
        "mapToExistingDriver": this.mapToExistingDriver,
        "remark": this.remark
      }
    } else {
      sendData = {
        "vehicleTypeId": this.vehicleType,
        "registrationNo": this.registrationNo,
        "siteId": this.data.siteId,
        "vendorMasterId": this.data.vendorMasterId,
        "driverName": this.driverName,
        "licenseNumber": this.licenseNumber,
        "contactNumber": this.contactNumber,
        "mapToExistingDriver": this.mapToExistingDriver,
        "remark": this.remark
      }
    }
    if (sendData) {
      this.ngxLoader.start();
      this.apiService.doPostRequestWithResponse(ApiConstants.addOutSourceVehicle, sendData, (success) => {
        this.ngxLoader.stop();
        if (success.status == 200) {
          if (success.body.message == 'Added successfully') {
            this.dialogRef.close(success.body.message);
            this.notifyService.showSuccess(success.body.message, null);
          } else {
            this.notifyService.showWarning(success.body.message, null);
          }
        }
      }, (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError("Failed to add", null);
      });
    }
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }
}
